import { watch } from 'vue';
import { usePrivacyStore } from '@/core/shared/privacy/privacy.store';

const PRIVACY_MODE_CLASS = 'privacy-mode';

/**
 * Applies the `privacy-mode` body class from the persisted privacy store for the
 * lifetime of the app. Call once at the app root (App.vue): the class then tracks
 * `privacyStore.isActive` across every route and viewport, including views where
 * neither PrivacyToggle nor MobileDrawer is mounted (the mobile /jobs candidate
 * view would otherwise render sensitive data unmasked). Components only toggle the
 * store, so the DOM side effect has one owner and cannot race across breakpoints.
 */
export function usePrivacyMode(): void {
  const privacyStore = usePrivacyStore();

  watch(
    () => privacyStore.isActive,
    (active) => {
      document.body.classList.toggle(PRIVACY_MODE_CLASS, active);
    },
    { immediate: true },
  );
}
